export const deLocale = {
	months: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
	],
	monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
	weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
	weekdaysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
	weekdaysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
	longDateFormat: {
		LT: "HH:mm",
		LTS: "HH:mm:ss",
		L: "DD.MM.YYYY",
		LL: "D. MMMM YYYY",
		LLL: "D. MMMM YYYY HH:mm",
		LLLL: "dddd, D. MMMM YYYY HH:mm",
	},
	calendar: {
		sameDay: "[Heute um] LT [Uhr]",
		sameElse: "L",
		nextDay: "[Morgen um] LT [Uhr]",
		nextWeek: "dddd [um] LT [Uhr]",
		lastDay: "[Gestern um] LT [Uhr]",
		lastWeek: "[letzten] dddd [um] LT [Uhr]",
	},
	relativeTime: {
		future: "in %s",
		past: "vor %s",
		s: "ein paar Sekunden",
		ss: "%d Sekunden",
		m: "einer Minute",
		mm: "%d Minuten",
		h: "einer Stunde",
		hh: "%d Stunden",
		d: "einem Tag",
		dd: "%d Tagen",
		M: "einem Monat",
		MM: "%d Monaten",
		y: "einem Jahr",
		yy: "%d Jahren",
	},
	dayOfMonthOrdinalParse: /\d{1,2}\./,
	ordinal: (n: number) => `${n}.`,
	week: {
		dow: 1, // Monday is the first day of the week.
		doy: 4, // The week that contains Jan 4th is the first week of the year.
	},
};
